module.exports = __webpack_public_path__ + "img/logo-footer-main.03fb8522.svg";